export default __webpack_public_path__ + "static/media/myphoto.e3ab36a6.jpeg";